import { useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import MyPageTemplate from 'components/template/MyPageTemplate';
import { INoticeList } from 'types/noti';
import { useNavigate } from 'react-router-dom';
import Loading from 'components/common/Loading';
import CustomInput from 'components/common/CustomInput';
import { ReactComponent as Reset } from 'assets/common/reset.svg'

const Notice = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [noticeList, setNoticeList] = useState<INoticeList[]>([]);
    const [text, setText] = useState<string>('');

    const tHeader = [
        { label: "No.", flex: 0.5 },
        { label: "공지일", flex: 1.0 },
        { label: "제목", flex: 2.0 },
    ];
    useEffect(() => {
        getNoticeList();
    }, [text])

    const getNoticeList = () => {
        setLoading(true)
        jsonAxios.get(`notice?search=${text}`).then(res => {
            if (res.data.code === 200) {
                setNoticeList(res.data.data)
            }
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 400)
        })
    }

    const titleStyle = () => {
        return `hidden tablet:block flex-[1.0] w-full bg-[#e5e5e5] py-1`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }

    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-25 h-full min-h-dvh'>
                <div className="flex flex-col gap-6 pt-10 tablet:pt-4">
                    <div className='flex flex-col gap-3 bg-white hover:shadow-lg rounded-xl w-full transition-all'>
                        <div className='flex justify-between items-center mobile:p-6 px-10 tablet:px-4 py-6 border-b'>
                            <p className='font-semibold tablet:text-lg text-2xl'>공지사항 검색</p>
                        </div>
                        <div className='flex items-center gap-4 mobile:p-6 px-10 tablet:px-4 py-6'>
                            <CustomInput
                                className='flex-1'
                                type='text'
                                placeholder='공지사항 제목 검색해주세요'
                                value={text}
                                onChange={(e) => {
                                    setText(e.target.value)
                                }}
                            />
                            <div className='flex-1'>
                                {
                                    text.length > 0 &&
                                    <div
                                        className='group flex justify-center items-center border rounded-md w-15 tablet:w-10 h-15 tablet:h-10 overflow-hidden cursor-pointer'
                                        onClick={() => {
                                            setText('')
                                        }}
                                    >
                                        <Reset className='group-hover:scale-120 transition-all' />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col gap-3 bg-white hover:shadow-lg p-10 mobile:p-6 tablet:px-4 rounded-xl w-full transition-all'>
                        {
                            loading ?
                                <div className='flex justify-center items-center w-full'>
                                    <Loading />
                                </div> :
                                <>
                                    <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                                        {
                                            tHeader.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                                >
                                                    {item.label}
                                                </div>
                                            ))
                                        }
                                    </div>

                                    {
                                        noticeList.length > 0 ?
                                            <div className='flex flex-col gap-3 min-h-[30vh]'>
                                                {
                                                    noticeList.map((item, idx) => (
                                                        <div
                                                            className={`flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20 cursor-pointer hover:bg-[#EEF4FF]`}
                                                            key={idx}
                                                            onClick={() => {
                                                                navigate(`/mypage/notice/detail?id=${item.id}`, { state: text })
                                                            }}
                                                        >
                                                            <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-6`}>
                                                                <span className={titleStyle()}>No</span>
                                                                <span className='flex-1'>
                                                                    {noticeList.length - idx}
                                                                </span>
                                                            </div>
                                                            <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-3`}>
                                                                <span className={titleStyle()}>공지일</span>
                                                                <span className='flex-1'>
                                                                    {item.createAt}
                                                                </span>
                                                            </div>
                                                            <div className={`flex-[2.0] ${tBodyStyle()} tablet:order-2`}>
                                                                <span className={titleStyle()}>제목</span>
                                                                <span className='flex-1'>
                                                                    {item.title}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            :
                                            <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                                데이터가 없습니다.
                                            </div>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default Notice